import { render, staticRenderFns } from "./partnershipDetail.vue?vue&type=template&id=09602dca"
import script from "./partnershipDetail.vue?vue&type=script&lang=ts"
export * from "./partnershipDetail.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports